<template>
    <div>
        <button  v-if="relationWithUser === 'hosted'" :class="getClass()" @click="joinFlight" type="button"
                class=" w-100 btn rounded-0 disabled-without-opacity" disabled>You Own This Trip
        </button>
        <template v-if="tripStatus !=9">
            <button v-if="relationWithUser === 'requested'" :class="getClass()" type="button"
                    class=" w-100 btn rounded-0 disabled-without-opacity" disabled >Request In Process
            </button>
            <button v-else-if="tripIsAnEmptyLeg" :class="getClass()" @click="joinFlight" type="button"
                    class=" w-100 btn rounded-0">I Want More Information
            </button>
            <button :id="buttonId" v-else-if="relationWithUser === 'available'" :class="getClass()" @click="joinFlight" type="button"
                    class=" w-100 btn rounded-0">Join Flight
            </button>
            <button :id="buttonId" v-else-if="relationWithUser === 'joined'" :class="getClass()" @click="joinFlight" type="button"
                    class=" w-100 btn rounded-0">Joined Flight</button>
            <button :id="buttonId" v-else-if="relationWithUser === 'not-logged-user'" :class="getClass()" @click="guestJoinFlight"
                    type="button" class=" w-100 btn rounded-0">Join Flight
            </button>
        </template>

        <subscribe-modal :visible="showSubscribeModal" @subscribed="subscribed" @close="closeSuscribeModal" />
    </div>
</template>

<script>
    import SubscribeModal from '@/components/User/SubscribeModal';
    import SubscribeMixin from '../../../../mixins/SubscribeMixin';
    import axios from 'axios';

    export default {
        components: {
            SubscribeModal
        },
        mixins: [SubscribeMixin],
        props: {
            tripStatus:{
                default:null,
            },
            tripId: {
                required:true,
            },
            tripIsAnEmptyLeg: {
                required: false,
                default: false,
                type: Boolean
            },
            relationWithUser: {
                required: true,
            }
        },
        created() {
            this.afterSubscribeAction = 'signUpAlert'
        },
        data() {
            return {
                showSubscribeModal:false,
            }
        },
        computed: {
            buttonId: function () {
                return 'trip-'+this.tripId+'-join-button';    
            }
        },
        methods: {
            closeSuscribeModal() {
                this.showSubscribeModal = false
            },
            joinFlight() {
                axios.post('/api/statistics', {name: 'JOIN_BUTTON_CLICKS'})
                if (this.relationWithUser === 'available') {
                    this.$emit('joinRequest', [1, 'I want to join your flight']);
                } else if (this.tripIsAnEmptyLeg && this.relationWithUser === 'not-logged-user') {
                    this.guestJoinFlight();
                }
            },
            getClass() {
                if (this.relationWithUser === 'joined' || this.relationWithUser === 'requested') {
                    return 'btn-success';
                } else if (this.relationWithUser === 'available') {
                    return 'btn-primary';
                } else if (this.relationWithUser === 'hosted') {
                    return 'btn-info'
                } else if (this.relationWithUser === 'not-logged-user') {
                    return 'btn-primary'
                }
            },
            guestJoinFlight() {
                if (!this.email) {
                    this.showSubscribeModal = true;
                } else {
                    this.signUpAlert()
                }
            },
            signUpAlert() {
                if (this.email) {
                    axios.post('/api/statistics', {name: 'JOIN_BUTTON_CLICKS'})
                }
                this.$emit('joinRequest');
            }
        },
    }
</script>
<style>
    .swal-long-text {
        text-align: justify;
    }
    .btn.disabled-without-opacity {
        opacity: 1;
    }
</style>
